'use strict';

var momentum = require('./momentum');

function use (moment) {
  this.moment = momentum.moment = moment;
}

module.exports = use;



//////////////////
// WEBPACK FOOTER
// ./~/rome/src/use.js
// module id = 297
// module chunks = 0